import {EndGameData, UserStatCategoryEnum} from '@colonist/game-base-types'
import {TranslationObject} from '@colonist/i18n'
import {NonFunctionProperties} from '@colonist/types'
import {BaseRankedUserState, RankedUserStateType} from './BaseRankedUserState'
import {RankedDivisionState} from './RankedDivisionState'

export class RankedMMRState extends BaseRankedUserState {
    readonly type = RankedUserStateType.Ranked

    readonly userStatCategory: UserStatCategoryEnum
    readonly promotionDemotionText: TranslationObject
    readonly mostRecentChangeInValue: number

    readonly previousMMR: number
    readonly currentMMR: number
    readonly currentDivisionState: RankedDivisionState
    readonly previousDivisionState: RankedDivisionState

    constructor(userStatCategory: UserStatCategoryEnum, previousMMR: number, currentMMR: number, previousDivisionState: RankedDivisionState, currentDivisionState: RankedDivisionState, promotionDemotionText: TranslationObject) {
        super()
        this.userStatCategory = userStatCategory
        this.mostRecentChangeInValue = Math.round(currentMMR - previousMMR)
        this.promotionDemotionText = promotionDemotionText

        this.previousMMR = Math.round(previousMMR)
        this.currentMMR = Math.round(currentMMR)
        this.currentDivisionState = currentDivisionState
        this.previousDivisionState = previousDivisionState
    }

    getEndGameScreenUpdateText(): TranslationObject {
        return {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: `${this.currentMMR}`,
            },
        }
    }

    getEndGameScreenMMRChangeText(): TranslationObject {
        const showPlus = '+'
        const showMinus = ''
        const mathSymbol = this.mostRecentChangeInValue > 0 ? showPlus : showMinus

        return {
            key: 'strings:game.endGame.rankedUpdate.rating',
            options: {
                ratingChange: `${mathSymbol}${this.mostRecentChangeInValue}`,
            },
        }
    }

    getEndGameData(): EndGameData {
        const showPlus = this.mostRecentChangeInValue > 0 ? '+' : ''
        const endGameData: EndGameData = {
            amount: `${showPlus}${this.mostRecentChangeInValue}`,
            highest: false,
        }
        return endGameData
    }

    getFindGamePopupStatusText(): TranslationObject {
        return {
            key: 'strings:colonistCommon.rankedState.rating',
            options: {
                rating: this.currentMMR,
            },
        }
    }

    static deserialize(data: NonFunctionProperties<RankedMMRState>): BaseRankedUserState {
        const previousDivisionState = RankedDivisionState.deserialize(data.previousDivisionState)
        const currentDivisionState = RankedDivisionState.deserialize(data.currentDivisionState)
        const newRankedState = new RankedMMRState(data.userStatCategory, data.previousMMR, data.currentMMR, previousDivisionState, currentDivisionState, data.promotionDemotionText)
        return newRankedState
    }
}
